import { Component } from '@angular/core';

@Component({
  selector: 'lma-root',
  template: '<router-outlet></router-outlet>'
})
export class AppComponent {
}
